import CustomFilterValueInputForIsComparison from 'components/CustomFilterValueInputForIsComparison'
import FilterInput from 'components/FilterInput'
import useFeatureToggle from 'hooks/useFeatureToggle'

export default function useGetComparisons(fieldType) {
  const { enableRelativeDateAudienceFilter } = useFeatureToggle()

  if (fieldType === 'datetime' && enableRelativeDateAudienceFilter) {
    return {
      comparisons: [
        { label: 'is before', value: 'is_before', inputComponent: null },
        { label: 'is on or after', value: 'is_on_or_after', inputComponent: null },
        { label: 'is unknown', value: 'is_unknown', inputComponent: null },
        { label: 'has any value', value: 'has_any_value', inputComponent: null },
      ],
    }
  }

  const comparisons = [
    { label: 'is', value: 'is', inputComponent: CustomFilterValueInputForIsComparison },
    { label: 'is not', value: 'is_not', inputComponent: CustomFilterValueInputForIsComparison },
    { label: 'contains', value: 'contains', inputComponent: FilterInput },
    { label: 'does not contain', value: 'does_not_contain', inputComponent: FilterInput },
    { label: 'is unknown', value: 'is_unknown', inputComponent: null },
    { label: 'has any value', value: 'has_any_value', inputComponent: null },
  ]
  return { comparisons }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useGetComparisons/index.js